import React from "react";
import SlideInOutAnimation from "../../util/SlideInOutAnimation";
import InfosysLogo from "../../assets/logo/infosys-logo.png";
import CognizantLogo from "../../assets/logo/cognizant-logo.png";
import MakautLogo from "../../assets/logo/makaut-logo.png";
import WbchseLogo from "../../assets/logo/wbchse-logo.png";
import WbbseLogo from "../../assets/logo/wbbse-logo.png";

const experiences = [
  {
    date: "2022 - Present",
    title: "SPECIALIST PROGRAMMER",
    company: "INFOSYS",
    logo: InfosysLogo,
    description:
      "Currently, I am working as a Specialist Programmer at Infosys, where I am involved in developing and maintaining software applications. My role requires me to utilize my programming skills to solve complex problems and deliver high-quality solutions. This position has allowed me to work with cutting-edge technologies and collaborate with a talented team of professionals from globally leading Tech & Logistics companies.",  
    },
  {
    date: "2022 - 2022",
    title: "INTERN",
    company: "COGNIZANT",
    logo: CognizantLogo,
    description:
      "As an intern, I was involved in various projects that required me to apply my programming skills in real-world scenarios. This experience helped me understand the dynamics of working in a corporate environment and the importance of teamwork and communication.",
  },
];

const educations = [
  {
    date: "2022",
    title: "ENGINEERING DEGREE",
    company: "MAKAUT",
    logo: MakautLogo,
    description:
      "I completed my B.Tech in Electrical Engineering from Maulana Abul Kalam Azad University of Technology (MAKAUT). With a diverse curriculum, I got opportunities to learn my interests in Software Engineering paradigms as well and established a strong base in programming languages, data structures, and algorithms.",
  },
  {
    date: "2018",
    title: "+2 SCHOOL DEGREE",
    company: "WBCHSE",
    logo: WbchseLogo,
    description:
      "I completed my Higher Secondary education from West Bengal Council of Higher Secondary Education (WBCHSE) in PCM. This phase of my education helped me develop a strong analytical mindset and a passion for technology, which eventually led me to pursue a career in software development.",
  },
  {
    date: "2015",
    title: "HIGH SCHOOL DEGREE",
    company: "WBBSE",
    logo: WbbseLogo,
    description:
      "I completed my Secondary education from West Bengal Board of Secondary Education (WBBSE). This foundational phase of my education instilled in me a love for learning and a curiosity about the world, setting the stage for my future academic and professional pursuits.",
  },
];

function TimelineColumn({ items }) {
  return (
    <SlideInOutAnimation className="relative px-10">
      {items.map((item, idx) => (
        <div key={idx} className="mb-10 relative">
          <div>
            {/* Vertical line through the item */}
            <div className="absolute left-4 top-5 h-[90%] w-px bg-yellow-800"></div>
            {/* Yellow icon on line */}
            <div className="absolute left-0 top-1 flex items-center justify-center w-8 h-8 border-2 border-yellow-500 bg-white rounded-full">
              <img
                src={item.logo || "https://via.placeholder.com/50"}
                alt={`${item.company} logo`}
                className="h-6 w-6 object-contain"
              />
            </div>
          </div>

          <div className="ml-12">
            {/* Date beside icon */}
            <span className="inline-block bg-gray-700 text-xs px-3 py-1 rounded-full mb-2">
              {item.date}
            </span>
            <h3 className="text-lg font-bold">
              {item.title}{" "}
              <span className="uppercase text-gray-400">— {item.company}</span>
            </h3>
            <p className="text-gray-400 text-sm">{item.description}</p>
          </div>
        </div>
      ))}
    </SlideInOutAnimation>
  );
}

function ExpAndEdu() {
  return (
    <section className="px-6 py-20 bg-black text-white">
      <SlideInOutAnimation>
        <h2 className="text-4xl font-bold text-center mb-16">
          EXPERIENCE & <span className="text-yellow-500">EDUCATION</span>
        </h2>
      </SlideInOutAnimation>
      <div className="grid md:grid-cols-2 gap-12">
        <TimelineColumn items={experiences} />
        <TimelineColumn items={educations} />
      </div>
    </section>
  );
}

export default ExpAndEdu;
